import { createReducer } from 'reduxsauce';
import { Types } from './types';
import { INITIAL_STATE } from './initialState';

export const partnersStart = state => ({
  ...state,
  isLoading: true,
  error: null,
});

export const partnersSuccess = (state, { data }) => ({
  ...state,
  data,
  isLoading: false,
});

export const partnersError = (state, { error }) => ({
  ...state,
  error,
  isLoading: false,
});

export const partnersCleanUp = () => INITIAL_STATE;

export const HANDLERS = {
  [Types.PARTNERS_START]: partnersStart,
  [Types.PARTNERS_SUCCESS]: partnersSuccess,
  [Types.PARTNERS_ERROR]: partnersError,
  [Types.PARTNERS_CLEAN_UP]: partnersCleanUp,
};

export default createReducer(INITIAL_STATE, HANDLERS);
